import React from 'react';
import { Box, Typography } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { COPY } from '../presentationCopy';
import { PresentationSettingsState, hexForSettingsColor } from '../presentationSettings';
import { createDefaultChart } from '../editor/chartModel';
import { renderChartSvg } from '../editor/chartSvg';

interface ChartDefaultsPreviewProps {
  settings: PresentationSettingsState;
}

const ChartDefaultsPreview: React.FC<ChartDefaultsPreviewProps> = ({ settings }) => {
  const defaults = settings.chartDefaults;
  const chart = createDefaultChart({
    kind: defaults.kind,
    showLegend: defaults.showLegend,
    showValues: defaults.showValues,
    colorIds: defaults.seriesColorIds,
    background: defaults.background,
  });
  const palette = Object.fromEntries(settings.colors.map((color) => [color.id, color.hex]));
  const svg = renderChartSvg({
    chart,
    width: 420,
    height: 180,
    palette,
    gridColor: hexForSettingsColor(settings, defaults.gridColorId, '#998A6B'),
    fontSize: Math.max(10, Math.min(16, defaults.fontSize || 14)),
  });

  return (
    <Box>
      <Typography sx={{ mb: 1, color: PRES.textSecondary, fontFamily: TYPE.ui, ...TYPE.label }}>
        {COPY.settingsChartPreview}
      </Typography>
      <Box
        sx={{ maxWidth: 420, '& svg': { display: 'block', width: '100%', height: 'auto' } }}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    </Box>
  );
};

export default ChartDefaultsPreview;
